import { objectToTranslatableChoices } from '@shared/choice';
import { TILE_DISPLACEMENT_COUNT_TRAD_KEYS } from '@shared/constants/externalDamages';
export const TILE_DISPLACEMENT_TITLE = 'claim.declaration.external_damages.form.tile_displacement.count.question';
export const TILE_DISPLACEMENT_COUNT_CHOICES = objectToTranslatableChoices(TILE_DISPLACEMENT_COUNT_TRAD_KEYS);
